import React, { ReactNode } from 'react'
import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import media from 'css-in-js-media'
import Title from './Title'
import { BodyCopy, H2 } from './Typography'
import { Variables } from '../styles/Variables'

const StyledText = styled(Title)`
    &:before,
    &:after {
        content: '';
        display: block;
        height: 9px;
        width: 50%;
        margin: auto;
        background-image: url("data:image/svg+xml,%3Csvg width='357' height='9' viewBox='0 0 357 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='7.71926e-09' y1='8' x2='357' y2='8' stroke='%23C8965A' stroke-width='2'/%3E%3Cline x1='7.71926e-09' y1='1' x2='357' y2='0.999997' stroke='%23C8965A' stroke-width='2'/%3E%3C/svg%3E");
        background-size: auto 9px;
        background-repeat: repeat-x;

        ${media('<desktop')} {
            width: calc(52% + 52px);
        }
    }

    &:before {
        margin-bottom: 77px;
        ${media('<desktop')} {
            margin-bottom: 66px;
        }
    }

    &:after {
        margin-top: 77px;
        ${media('<desktop')} {
            margin-top: 66px;
        }
    }

    ${media('>desktop')} {
        margin: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    ${BodyCopy} {
        margin: 0;
    }
    ${BodyCopy} {
        text-transform: uppercase;
        font-size: 16px;
        ${media('<desktop')} {
            font-size: 14px;
        }
    }
    ${H2} {
        max-width: 324px;
        margin: 0 auto;
        ${media('<desktop')} {
            max-width: 280px;
        }
        p {
            display: block;
            margin-top: 40px;
            white-space: pre-line;
            ${media('<desktop')} {
                margin-top: 30px;
            }
        }

        ${media('<desktop')} {
            margin-top: 30px;
        }
    }

    ${media('<desktop')} {
        margin: 31px 20px;
        text-align: center;
    }
`

const StyledFrame = styled(Col)`
    position: relative;
    height: 100vh;
    min-height: 900px;
    padding: 60px 50px;
    background-color: ${Variables.color.pink};

    ${media('<desktop')} {
        min-height: 549px;
        height: 100%;
        padding: 0 30px;
    }

    &:after,
    &:before {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
    }
`

interface Props {
    mobileWidth: number
    width: number
    data: ReactNode
}

const Frame = ({ width, mobileWidth, data }: Props) => {
    return (
        <StyledFrame xs={mobileWidth} md={width}>
            <StyledText align="center">{data}</StyledText>
        </StyledFrame>
    )
}

export default Frame
